module.exports = __webpack_public_path__ + "static/media/TechPositions.12aec417.svg";